export default __webpack_public_path__ + "static/media/Wildstrider Tasset.6956ceda.jpg";